import segment from "./segment"
import ga from "./ga"
import make from "./make"

const STORAGE_KEY = "@mobi/analytics"

let trackEvents = {}

const setup = ({
  segmentId,
  GTMId,
  makeTagular: { writeKey, sourceKey },
  trackings,
  isSDKTrackings = false,
} = {}) => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      segmentId,
      GTMId,
      makeTagular: {
        writeKey,
        sourceKey,
      },
      isSDKTrackings,
    })
  )

  if (writeKey && sourceKey) {
    make.setup()
  }

  trackEvents = trackings
}

const track = (name, data) => {
  if (name in trackEvents) {
    const event = trackEvents[name]
    return event(data)
  } else {
    const error = new Error(`[@analytics] ${name} does not exit in events`)

    return Promise.reject(error)
  }
}

export default {
  setup,
  track,
}

export { segment, ga, make }
